<template>
    <!-- 票台管理 － 售票信息 -->
    <div>
        <content-view class="ticketSaleInfo" v-show="$utils.renderWhen(this,'cashierSaleInfo')">
            <div slot="header">
                <a-form :form="form" layout="inline">
                    <a-form-item label="票券名称">
                        <a-input placeholder="请输入" v-decorator="['ticketTemplateName']"></a-input>
                    </a-form-item>
                    <a-form-item label="类型" >
                        <a-select v-decorator="['type']" placeholder="请选择" allowClear >
                            <a-select-option value="1">期限卡</a-select-option>
                            <a-select-option value="2">次卡</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <div  class="wrap-container-in">
                <a-tabs :defaultActiveKey="1" :animated="false" @change="onTabChange">
                    <a-tab-pane tab="绑定且展示至该票台" :key="1">
                    </a-tab-pane>
                    <a-tab-pane tab="绑定且不展示至该票台" :key="0">
                    </a-tab-pane>
                </a-tabs>
                <a-table
                    bordered
                    :dataSource="dataSource"
                    :columns="columns"
                    :pagination="pagination"
                    @change="changePage"
                    :rowKey="record => record.id"
                    :loading="loading"
                    >
                    <span slot="index" slot-scope="a, row, index">{{index+1}}</span>
                    <span slot="ticketType" slot-scope="key">{{key | ticketType}}</span>
                    <span slot="state" slot-scope="key">{{key ? '已展示' : '不展示'}}</span>
                    <span slot="action" slot-scope="a, row">
                        <span v-if="getBtnByAuth('detailDeskCashier')">
                            <router-link class="text-primary" :to="{ name: 'counterTicketDetail', query: { ticketTemplateId: row.ticketTemplateId } }">详情</router-link>
                            <a-divider type="vertical"/>
                        </span> 
                        <a-popconfirm
                        v-if="getBtnByAuth('ticketToShelf')"
                        :title="`确定将票台上的该门店票券${row.isShow ? '不展' : '展'}示至该票台吗?`"
                        @confirm="changeState(row.ticketTemplateId, !row.isShow)"
                        >
                            <a class="text-primary">{{row.isShow ? '不展' : '展'}}示至该票台</a>
                        </a-popconfirm>
                    </span>
                </a-table>  
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    //  默认表头
    const columns = [
        {
            title: "序号",
            dataIndex: "index",
            scopedSlots: { customRender: "index" }
        },
        {
            title: "票券名称",
            dataIndex: "name"
        },
        {
            title: "类型",
            dataIndex: "type",
            scopedSlots: { customRender: "ticketType" }
        },
        {
            title: "销量",
            dataIndex: "sellNum"
        },
        {
            title: "售价",
            dataIndex: "sellShowPrice"
        },
        {
            title: "状态",
            dataIndex: "isShow",
            scopedSlots: { customRender: "state" }
        },
        {
            title: "操作",
            scopedSlots: { customRender: "action" }
        }]
    export default {
        name: "ticketSaleInfo",
        components: {},
        props: {},
        data() {
            return {
                columns,
                noTitleKey: 1,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showQuickJumper: true,
                    showSizeChanger: true,
                    current: 1,
                    pageSize: 20,
                    total: 0,
                },
                form: null,
                loading: false
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        watch: {
            shopId() {
                this.getList();
            }
        },
        methods: {
            handleReset () {
                this.form.resetFields();
                this.search();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            onTabChange(noTitleKey) {
                this.noTitleKey = noTitleKey;
                this.pagination.current = 1;
                this.getList();
            },
            // 获取审核管理我发起的表格分页数据
            changePage(page) {
                this.pagination = page;
                this.getList();
            },

            // 获取售票信息列表
            getList() {
                if (!this.shopId || this.loading) {
                    return false
                }
                this.form.validateFields((err, values) => {
                    if (!err) {
                        this.loading = true;
                        this.$api.ticketDesk.sellInfoCashier({
                            body: {
                                ...values,
                                counterId: this.$route.params.id,
                                isShow: Boolean(this.noTitleKey),
                                pageNum: this.pagination.current,
                                pageSize: this.pagination.pageSize,
                                shopId: this.shopId
                            }
                        }).then(res => {
                            this.loading = false;
                            this.pagination.total = res.total;
                            this.dataSource = res.list;
                        }).catch(err => {
                            this.loading = false;
                        });
                    }
                })
                
            },
            // 修改状态
            changeState(ticketTemplateId, isShow) {
                if (!this.shopId || this.loading) {
                    return false;
                }
                this.loading = true;
                this.$api.ticketDesk.ticketShelveState({
                    body: {
                        ticketTemplateId,
                        isShow: isShow,
                        counterId: this.$route.params.id,
                        shopId: this.shopId
                    }
                }).then(data=>{
                    this.$message.success('操作成功');
                    this.loading = false;
                    this.getList();
                }).catch(err => {
                    this.loading = false;
                })
            },
        },
        created() {
            this.form = this.$form.createForm(this);
        },
        mounted() {
            this.getList();
        }
    };
</script>
<style lang="scss">
</style>